import axios from "axios"
import { Service } from "../services/Service"

const serverBaseURL = process.env.REACT_APP_API_BASE_URL
class SearchApi {
    public static async search(
        value: string,
        index: string,
        sections?: Array<string>,
        optional?: { must: Array<{ term: any }>; should: Array<{ term: any }> }
    ): Promise<any> {
        const headers = await Service.getRequestHeaders()
        // construction de la query param
        let queryParams = `?q=${value}`

        queryParams += index ? `&index=${index}` : ""
        queryParams += sections ? `&sections=${sections}` : ""
        queryParams += optional ? `&optional=${JSON.stringify(optional)}` : ""
        const response = await axios.get(
            `${serverBaseURL}/search/${queryParams}`,
            {
                headers,
            }
        )
        return response.data
    }
}

export default SearchApi
